import common from '../common';
import Text from './Text';

export default class StatisticPanel extends PIXI.Container {
	constructor(type) {
		super();

		this._panel = null;
		this._items = [];
		this._type = type;

		this._init();

		this._langSignal = common.languageManager.signals.changed.add(() => {
			P3.utils.performNextTick(() => {
				this.resize();
			});
		});
	}

	_init() {
		this._panel = this._createBackground();
		this.addChild(this._panel);
	}

	_createBackground() {
		const container = new PIXI.Container();

		const l1 = new PIXI.Sprite(P3.assets.texture('panel_stats_l1'));

		l1.anchor.set(0);
		l1.position.set(0, 0);
		container.addChild(l1);

		const l2 = new PIXI.Sprite(P3.assets.texture('panel_stats_l2'));

		l2.anchor.set(0);
		l2.position.set(l1.x + l1.width, 0);
		l2.width = StatisticPanel.LEFT_MIN;
		container.addChild(l2);

		const m = new PIXI.Sprite(P3.assets.texture('panel_stats_m'));

		m.anchor.set(0);
		m.position.set(l2.x + l2.width, 0);
		container.addChild(m);

		const r2 = new PIXI.Sprite(P3.assets.texture('panel_stats_r2'));

		r2.anchor.set(0);
		r2.position.set(m.x + m.width, 0);
		r2.width = StatisticPanel.RIGHT_MIN;
		container.addChild(r2);

		const r1 = new PIXI.Sprite(P3.assets.texture('panel_stats_r1'));

		r1.anchor.set(0);
		r1.position.set(r2.x + r2.width, 0);
		container.addChild(r1);

		container.leftBorder = l1;
		container.leftSlice = l2;
		container.middleBorder = m;
		container.rightSlice = r2;
		container.rightBorder = r1;

		return container;
	}

	addItem(id, labelText, valueText, icon = null) {
		const item = new PIXI.Container();

		const index = this._items.length;
		const tint = index > 0 ? 0x0 : 0xffffff;
		const fontWeight = index > 0 ? 'normal' : 'bold';

		const label = new Text(labelText, { font: '30px', fontWeight, align: 'left', tint });

		label.position.set(this._panel.leftSlice.x, 0);
		item.addChild(label);

		let valueX = this._panel.rightSlice.x;

		if (icon) {
			const iconSprite = new PIXI.Sprite(P3.assets.texture(icon));

			iconSprite.tint = tint;
			iconSprite.anchor.set(0, 0);
			iconSprite.position.set(this._panel.rightSlice.x, 0);
			item.addChild(iconSprite);
			valueX = iconSprite.x + iconSprite.width;
			item.icon = iconSprite;
		}

		const value = new Text(valueText, { font: '30px', fontWeight, align: 'right', tint });

		value.anchor.set(0, 0);
		value.position.set(valueX, 0);
		item.addChild(value);

		item.position.set(0, 14 + index * 35);

		item.id = id;
		item.label = label;
		item.value = value;

		this._panel.addChild(item);
		this._items.push(item);

		this.resize();
	}

	getItem(id) {
		return this._items.find((item) => item.id === id);
	}

	resize() {
		this._panel.leftSlice.width = Math.max(StatisticPanel.LEFT_MIN, this._getLargestLabelWidth()) + 5;
		this._panel.middleBorder.position.set(this._panel.leftSlice.x + this._panel.leftSlice.width, 0);
		this._panel.rightSlice.width = Math.max(StatisticPanel.RIGHT_MIN, this._getLargestValueWidth());
		this._panel.rightSlice.position.set(this._panel.middleBorder.x + this._panel.middleBorder.width, 0);
		this._panel.rightBorder.position.set(this._panel.rightSlice.x + this._panel.rightSlice.width, 0);

		for (let i = 0; i < this._items.length; ++i) {
			const { label, value, icon } = this._items[i];

			label.position.set(this._panel.leftSlice.x, label.y);

			let valueX = this._panel.rightSlice.x + 5;

			if (icon) {
				icon.position.set(valueX, icon.y);
				valueX = icon.x + icon.width + 5;
			}

			value.position.set(valueX, value.y);
		}
	}

	_getLargestLabelWidth() {
		let width = 0;

		for (let i = 0; i < this._items.length; ++i) {
			width = Math.max(width, this._items[i].label.width);
		}

		return width;
	}

	_getLargestValueWidth() {
		let width = 0;

		for (let i = 0; i < this._items.length; ++i) {
			width = Math.max(width, this._items[i].value.width);
		}

		return width;
	}

	destroy() {
		this._panel.destroy({ children: true });
		this._panel = null;
		this._items = [];

		common.languageManager.signals.changed.detach(this._langSignal);

		super.destroy({ children: true });
	}

	get type() {
		return this._type;
	}
}

StatisticPanel.LEFT_MIN = 100;
StatisticPanel.RIGHT_MIN = 80;
